import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { PageHeaderComponent } from './page-header.component';
import { PageHeaderTitleComponent } from './page-header-title.component';
import { PageHeaderDateComponent } from './page-header-date.component';
import { PageHeaderToolbarComponent } from './page-header-toolbar.component';

@NgModule({
  imports: [
    TranslateModule.forChild(),
    PageHeaderComponent,
    PageHeaderTitleComponent,
    PageHeaderDateComponent,
    PageHeaderToolbarComponent
  ],
  declarations: [
  ],
  exports: [
    PageHeaderComponent,
    PageHeaderTitleComponent,
    PageHeaderDateComponent,
    PageHeaderToolbarComponent
  ]
})
export class PageHeaderModule {
}
